import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useSelector } from 'react-redux';
import { getWhichOAuthEndpointFailed } from '../store/app/selectors';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Step } from '../views/Step';
const StyledValidationContainer = styled.div.withConfig({
  displayName: "OAuthVerificationFailureText__StyledValidationContainer",
  componentId: "w4lsbb-0"
})(["display:flex;justify-content:center;margin-top:8px;text-align:center;"]);
export const OAuthVerificationFailureText = ({
  oAuth
}) => {
  const failedOAuth = useSelector(getWhichOAuthEndpointFailed);
  const messageKey = `views.${Step.LandingPage}.oAuthFailHelperText.${oAuth}`;

  if (oAuth !== failedOAuth || !isValidI18nKey(messageKey)) {
    return null;
  }

  return /*#__PURE__*/_jsx(StyledValidationContainer, {
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: messageKey
      })
    })
  });
};